import { Box, Button, Dialog, Heading, Icon, Text } from '@redriverpress/system'
import PropTypes from 'prop-types'

export default function RequestMicPermissionDialog({
  isOpen,
  onConfirm,
  onOpenChange,
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.StyledContent
          onPointerDownOutside={e => {
            e.preventDefault()
            onOpenChange(false)
          }}
        >
          <Dialog.StyledTitle>
            <Heading as='h6' mb={0}>
              Please enable microphone permission
            </Heading>
          </Dialog.StyledTitle>

          <>
            <Icon icon='microphone-slash' color='blue700' mb={1} fontSize={4} />
            <Text fontSize={3} fontWeight='600' textAlign='center'>
              Please enable microphone permission
            </Text>
            <Text textAlign='center' mt={1} px={[3, null, 5]}>
              Click the <Icon icon='video' weight='solid' /> icon in your
              browser&apos;s address bar, set the correct permission, and then
              refresh this&nbsp;page.
            </Text>
            <Box textAlign='center' mt={4}>
              <Button small onClick={onConfirm}>
                <Icon icon='check' pr={2} />
                Okay
              </Button>
            </Box>
          </>
        </Dialog.StyledContent>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

RequestMicPermissionDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func.isRequired,
}
